var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProductlistEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 244,
    viewBox: "0 0 221 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5168 52.2359L19.1584 47.3201L13.4458 56.0806L11.5157 45.8281L0.967932 46.8993L7.92828 39.0569L0.5 31.6163L11.1062 32.0754L12.393 21.7273L18.6515 30.1435L27.6785 24.6921L24.8709 34.7341L34.8533 38.2536L25.1049 42.366L28.5168 52.2359Z",
    fill: "#FF0055"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.75 67.5947L219.566 75.2849L207.585 85.8754L215.846 100.937L181.031 93.2468L184.75 67.5947Z",
    fill: "#341490"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.333 58.1628L167.881 59.2726L157.412 123.608L151.864 122.498L162.333 58.1628Z",
    fill: "#6337E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166.692 58.9688L204.714 67.3576L200.857 93.924L162.835 85.5352L166.692 58.9688Z",
    fill: "#6337E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.465 197.182L115.478 178.057L128.957 120.766L89.0362 112.373L82.7524 138.647V178.057L86.3643 197.182H122.465Z",
    fill: "#F39CED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.707 104.305L102.832 100.309C98.5192 99.1531 96.2401 94.4066 98.0413 90.2996L105.381 73.5024L124.557 78.6547L117.707 104.305Z",
    fill: "#231815"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8453 81.5701L36.56 63.4128C36.56 63.4128 36.2425 60.4944 38.9173 54.4624C41.5921 48.4303 44.1081 46.3667 44.1081 46.3667L97.4208 78.0046L95.8453 81.5701Z",
    fill: "#6337E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6258 66.1685L88.4468 69.2422L84.3696 76.1395L89.81 69.9669L91.5538 70.8791L82.9205 83.0367L73.2188 75.9021L82.6258 66.1685Z",
    fill: "#231815"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110.854 156.377L53.417 120.11L58.4662 102.105L128.958 120.831L110.854 156.377Z",
    fill: "#F39CED"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.426 178.825L158.003 116.033C159.021 110.96 155.168 106.218 150.042 106.218H136.483C132.606 106.218 129.262 108.992 128.51 112.831L115.63 178.825H145.438H145.426Z",
    fill: "#F44377"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M139.591 110.906C147.895 110.906 154.626 104.174 154.626 95.871C154.626 87.5675 147.895 80.8362 139.591 80.8362C131.288 80.8362 124.557 87.5675 124.557 95.871C124.557 104.174 131.288 110.906 139.591 110.906Z",
    fill: "#F44377"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M150.214 106.685C149.076 106.103 147.769 105.772 146.365 105.772H132.819C131.427 105.772 130.108 106.114 128.958 106.696C131.657 109.286 135.422 110.906 139.586 110.906C143.75 110.906 147.527 109.286 150.226 106.685H150.214Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7524 138.775L115.339 178.379H122.356L91.5916 141.394L82.7524 138.775Z",
    fill: "#F44377"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7859 119.707L80.553 80.1488L77.1889 77.1697L52.7536 95.3372C44.4102 101.54 44.9567 114.25 53.7859 119.707Z",
    fill: "#231815"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductlistEmpty);
export default __webpack_public_path__ + "static/media/icon_productlist_empty.5b488218ab9fcd8bda1b8f59846d58cb.svg";
export { ForwardRef as ReactComponent };